import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-garage',
  imports: [],
  templateUrl: './garage.component.html',
  styleUrl: './garage.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GarageComponent { }
